import * as i0 from '@angular/core';
import { Injectable, inject, NgModule } from '@angular/core';
import { AnalyticsService } from '@engineering11/web-api-firebase';
import { ScreenTrackingService, UserTrackingService, provideAnalytics, getAnalytics } from '@angular/fire/analytics';

class IAnalyticsEventService {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: IAnalyticsEventService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: IAnalyticsEventService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: IAnalyticsEventService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class GoogleAnalyticsService {
    constructor() {
        this.analyticsService = inject(AnalyticsService);
    }
    async logEvent(event) {
        return this.analyticsService.logEvent(event.name, event.value);
    }
    async setUserProperties(properties) {
        return this.analyticsService.setUserProperties(properties);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: GoogleAnalyticsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: GoogleAnalyticsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: GoogleAnalyticsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class AnalyticsModule {
    static forRoot(config) {
        return {
            ngModule: AnalyticsModule,
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: AnalyticsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: AnalyticsModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: AnalyticsModule, providers: [
            ScreenTrackingService,
            UserTrackingService,
            {
                provide: IAnalyticsEventService,
                useClass: GoogleAnalyticsService, // It can be overridden by the implementation application
            },
            provideAnalytics(() => getAnalytics()),
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: AnalyticsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [],
                    exports: [],
                    providers: [
                        ScreenTrackingService,
                        UserTrackingService,
                        {
                            provide: IAnalyticsEventService,
                            useClass: GoogleAnalyticsService, // It can be overridden by the implementation application
                        },
                        provideAnalytics(() => getAnalytics()),
                    ],
                }]
        }] });

/*
 * Public API Surface of analytics
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AnalyticsModule, GoogleAnalyticsService, IAnalyticsEventService };
